import React from 'react';
import {
    Answer,
    AttestationProtection,
    Bookmarks,
    DetailAttestation,
} from '~/components/Patient/Attestations';
import { RemindersIcon } from '~/components/Reminders';
import { usePatientService } from '~/services';
import { formatDate, statusStyle } from '~/util';

interface AttestationCardProps {
    riskGap: RiskGapType;
    patientId: number;
    patientGmpi: number;
    disabled?: boolean;
    submission?: null | PatientSubmissionType;
    className: string;
}
export function AttestationCard({
    riskGap,
    submission = null,
    patientId,
    patientGmpi,
    disabled = false,
    className,
}: AttestationCardProps) {
    const { riskGapResponse } = usePatientService();
    const [answer, setAnswer] = React.useState(riskGap.uiAnswer);
    React.useEffect(() => {
        setAnswer(riskGap.uiAnswer);
    }, [riskGap.uiAnswer]);

    async function handleChange(e: {
        target: {
            value: boolean;
        };
    }) {
        setAnswer(e.target.value);
        try {
            await riskGapResponse(riskGap.id, e.target.value, riskGap.updated_at ?? null);
        } catch (error) {
            // empty catch
        }
    }

    return (
        <div className={`gap-card risk-gap-card ${className}`}>
            <DetailAttestation
                riskGap={riskGap}
                patientId={patientId}
                className={`card mb-2 border-${statusStyle(riskGap.status)}`}
            >
                <div className={`card-body row border-${statusStyle(riskGap.status)}`}>
                    <div className="col icons-col">
                        <AttestationProtection riskGap={riskGap} submission={submission} />
                        <RemindersIcon gap={riskGap} />
                        <Bookmarks riskGap={riskGap} patientGmpi={patientGmpi} />
                    </div>
                    <div className="col-8 action-container">
                        <div className="row title">
                            <div className="col-5 d-inline-flex">
                                <span
                                    className="text-truncate gap-card-title"
                                    title={riskGap.is_added ? riskGap.code : riskGap.icd!.code}
                                >
                                    {riskGap.is_added ? riskGap.code : riskGap.icd!.code}
                                </span>
                            </div>
                            {riskGap.referral_date && (
                                <div className="col text-center fst-italic" title="Reference Date">
                                    {formatDate(riskGap.referral_date)}
                                </div>
                            )}
                        </div>
                        <div className="row">
                            <div
                                className="col description"
                                title={
                                    riskGap.is_added
                                        ? riskGap?.description
                                        : riskGap.icd?.description
                                }
                            >
                                {riskGap.is_added ? riskGap?.description : riskGap.icd?.description}
                            </div>
                        </div>
                    </div>
                    <div className="col answer-container">
                        <Answer
                            hcc={riskGap}
                            answer={answer}
                            handleInputChange={handleChange}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </DetailAttestation>
        </div>
    );
}
